<template>
        <div class="modal-dialog modal-dialog-centered modal-fullscreen">
            <div class="modal-content"  >
                <div class="modal-header" id="kt_modal_add_user_header">
                    <h2 class="modal-title fw-bolder col-md-10">
                        {{ this.listType == 1 ? $t('collection_detail') : $t('payment_detail')  }}                     
                    </h2>  
                    <div class="btn btn-icon btn-sm btn-active-icon-primary"
                        data-bs-dismiss="modal" ::aria-label="$t('close')" ref="closeModal">
                        <span class="svg-icon svg-icon-1 text-hover-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                    transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                    transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="modal-body scroll-y">
                        <div class="row"> 
                             <div class="card p-0">  
                                <div class="card-body px-3">
                                    <div>
                                        <div class="table-responsive min-h-300px">
                                            <DxDataGrid id="gridContainer"
                                                :key="$i18n.locale"
                                                :show-borders="true"
                                                key-expr="id"
                                                :data-source="this.detailList"
                                                :allow-column-reordering="true" 
                                                :allow-column-resizing="true"
                                                :column-auto-width="true"
                                                :row-alternatin-enabled="true"
                                                :hover-state-enabled="true" 
                                                :show-row-lines="true" 
                                                :ref="'dataGrid'"
                                                @exporting="this.$onExporting($event , 'Collection-List')">

                                                <DxFilterRow :visible="true"/>
                                                <DxHeaderFilter :visible="true"/>
                                                <DxGroupPanel :visible="true"/>      
                                                <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                                <DxPaging :page-size="pageSize"/>
                                                <DxPager :visible="false" :allowed-page-sizes="pageSizesLists" :show-page-size-selector="showPageSizeSelectorLists" :show-info="true" :show-navigation-buttons="true"/>    
                                                <DxSearchPanel :visible="true"/>
                                                <DxScrolling
                                                    mode="virtual"
                                                    row-rendering-mode="virtual"
                                                />
                                                <DxColumn data-field="transaction_date" data-type="date" alignment="right" format="dd.MM.yyyy" :caption="$t('transaction_date')" header-cell-template="transaction_date-header"/>
                                                <DxColumn data-field="transaction_due_date" :caption="$t('transaction_due_date')" data-type="date" alignment="right" format="dd.MM.yyyy" header-cell-template="transaction-duedate-header"/> 
                                                <DxColumn data-field="account_name" :caption="$t('account')" />
                                                <DxColumn data-field="transaction_type_name" :caption="$t('transaction_type')" header-cell-template="collection-type-header"/> 
                                                <DxColumn data-field="transaction_subtype_name" :caption="$t('sub_type')" header-cell-template="collection-subtype-header"/> 
                                                <DxColumn data-field="transaction_no" :caption="$t('transaction_no')"  header-cell-template="transaction-no-header"/>
                                                <DxColumn data-field="currency" :caption="$t('currency')"/> 
                                                <DxColumn data-field="amount" :sorting-method="this.$numericSort" :caption="$t('amount')" alignment="right"/> 
                                                <DxColumn data-field="rate" :sorting-method="this.$numericSort" :caption="$t('rate')" alignment="right"/> 
                                                <DxColumn data-field="used_amount" :sorting-method="this.$numericSort" :caption="$t('collected_amount')" alignment="right" header-cell-template="collected-amount-header"/> 
                                                <DxColumn data-field="remain_amount" :sorting-method="this.$numericSort" :caption="$t('remain_amount')" alignment="right" header-cell-template="remain-amount-header"/> 
                                                <DxColumn data-field="local_amount" :sorting-method="this.$numericSort" :caption="$t('local_amount')" alignment="right" header-cell-template="amount-local-header"/> 
                                                <DxColumn data-field="used_local_amount" :sorting-method="this.$numericSort" :caption="$t('collected_local_amount')" alignment="right" header-cell-template="collected-local-amount-header"/> 
                                                <DxColumn data-field="remain_local_amount" :sorting-method="this.$numericSort" :caption="$t('remain_local_amount')" alignment="right" header-cell-template="remain-amount-local-header"/> 
                                                <DxColumn data-field="record_date" data-type="date" alignment="right" format="dd.MM.yyyy" :caption="$t('record_date')" header-cell-template="record-date-header"/>

                                                <!-- Yerel para birimi gösterimi için özel sütun şablonu oluşturulur --> 
                                                <template #headerLocalTemplate="{ data: data }">
                                                    <div v-html="setColumnTemplateForLocal(data)"></div> 
                                                </template>

                                                <template #record-date-header>
                                                    <div>{{ $t('record_date') }}</div>
                                                </template>
                                                <template #transaction_date-header>
                                                    <div>{{ $t('transaction_date') }}</div>
                                                </template>
                                                <template #collection-type-header>
                                                    <div>{{ $t('transaction_type') }}</div>
                                                </template>
                                                <template #collection-subtype-header>
                                                    <div>{{ $t('transaction_subtype') }}</div>
                                                </template>
                                                <template #transaction-no-header>
                                                    <div>{{ $t('transaction_no') }}</div>
                                                </template>
                                                <template #transaction-duedate-header>
                                                    <div>{{ $t('transaction_due_date') }}</div>
                                                </template>
                                                <template #collected-amount-header>
                                                    <div>{{ $t('collected_amount') }}</div>
                                                </template>
                                                <template #amount-local-header>
                                                    <div>{{ $t('amount_local') }}</div>
                                                </template>
                                                <template #collected-local-amount-header>
                                                    <div>{{ $t('collected_local_amount') }}</div>
                                                </template>
                                                <template #remain-amount-header>
                                                    <div>{{ $t('remain_amount') }}</div>
                                                </template>
                                                <template #remain-amount-local-header>
                                                    <div>{{ $t('remain_local_amount') }}</div>
                                                </template>
                                                <template #first-rate-header>
                                                    <div>{{ $t('first_rate') }}</div>
                                                </template>
                                                <template #last-local-amount-header>
                                                    <div>{{ $t('last_local_amount') }}</div>
                                                </template>

                                                <DxStateStoring
                                                    :enabled="true"
                                                    type="custom"
                                                    :storage-key="this.storageKey"
                                                    :ref="dataGrid" 
                                                    :saving-timeout="1000"
                                                    :custom-load="LoadDXState"
                                                />

                                                <DxSummary :calculate-custom-summary="setSummaries">
                                                    <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="transaction_due_date"/>
                                                    <DxGroupItem
                                                        :show-in-group-footer="true"
                                                        name="amount"
                                                        summary-type="custom"
                                                        show-in-column="amount"
                                                        display-format="{0}"
                                                    /> 
                                                    <DxTotalItem 
                                                        name="amount"
                                                        summary-type="custom"
                                                        show-in-column="amount"
                                                    />
                                                    <DxGroupItem
                                                        :show-in-group-footer="true"
                                                        name="local_amount"
                                                        summary-type="custom"
                                                        show-in-column="local_amount"
                                                        display-format="{0}"
                                                    /> 
                                                    <DxTotalItem name="local_amount"
                                                        summary-type="custom"
                                                        show-in-column="local_amount"
                                                    />
                                                    <DxGroupItem
                                                        :show-in-group-footer="true"
                                                        name="used_local_amount"
                                                        summary-type="custom"
                                                        show-in-column="used_local_amount"
                                                        display-format="{0}"
                                                    /> 
                                                    <DxTotalItem name="used_local_amount"
                                                        summary-type="custom"
                                                        show-in-column="used_local_amount"
                                                    />
                                                    <DxGroupItem
                                                        :show-in-group-footer="true"
                                                        name="remain_local_amount"
                                                        summary-type="custom"
                                                        show-in-column="remain_local_amount"
                                                        display-format="{0}"
                                                    /> 
                                                    <DxTotalItem name="remain_local_amount"
                                                        summary-type="custom"
                                                        show-in-column="remain_local_amount"
                                                    />
                                                </DxSummary>
                                            </DxDataGrid> 
                                        </div>
                                    </div> 
                                </div>
                            </div> 
                        </div>
                </div>
            </div>
        </div>

</template>

<script>
// import axios from 'axios';
// import moment from 'moment';
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxStateStoring, DxTotalItem, DxSummary, DxGroupItem, DxScrolling } from 'devextreme-vue/data-grid';
    
export default {
    name: "OffsetDetailList",
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxStateStoring, DxTotalItem, DxSummary, DxGroupItem, DxScrolling
    }, 
    props:{
        listType : String,
        detailList : Object,
    },
    data() {
        return {
            storageKey: 'dx_' + this.$options.name,
            pageSize: 100,
            pageSizeDetailList: 10,
            lists : [],
        }
    },
    computed:{
        showPageSizeSelectorLists() {
            return this.lists.length > this.pageSize;
        },
        pageSizesLists() {
            let arr = [];
            let x = 1;
            let loop = (this.lists.length / this.pageSize);
            for (let i = 1; i <= loop && i <= 5; i++) {
                arr.push(this.pageSize * x);
                x++;
            }
            if(loop > 5) arr.push(1000);
            if(loop > 1) arr.push('all');
            return arr;
        },
        setColumnTemplateForLocal(){
            return (value)=>{
                const captionValue = value.column.caption.replace(this.$t('local'), ' ');
                return this.localCurrency == null ? this.$t(captionValue) : this.localCurrency + '<br>' + this.$t(captionValue);
            }
        },
    },
    methods:{
        /** DX STATE OPERATIONS **/  
        LoadDXState() {
            return JSON.parse(sessionStorage.getItem(this.storageKey));
        }, 
        setSummaries(options){  
            const optionNames = ["amount", "local_amount", "used_local_amount","remain_local_amount"]; 
            optionNames.forEach(item => {
                if(options.name == item){
                    if(options.summaryProcess === 'start'){ options.totalValue = 0; }
                    else if(options.summaryProcess === 'calculate'){
                        var itemValue = parseFloat(options.value[item].replaceAll(',', ''));
                        (options.totalValue += itemValue);
                    }
                    else if(options.summaryProcess === 'finalize'){ 
                        options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
                    }
                }
            });
        },
    }
}
</script>

<style>

</style>